{
    "name": "Tomato",
    "binomial_name": "Solanum lycopersicum",
    "common_names": [
        "Tomato",
        "Tomate"
    ],
    "description": "The tomato is the fruit of the tomato plant, a member of the Nightshade family (Solanaceae). The fruit grows on a small compact bush.",
    "sun_requirements": "Full Sun",
    "sowing_method": "Direct seed indoors, transplant seedlings outside after hardening off",
    "spread": 45,
    "row_spacing": 45,
    "height": 45,
    "growing_degree_days": 75,
    "companions": [],
    "image": "/crops/images/tomato.jpg",
    "icon": "/crops/icons/tomato.avif"
}